import { render, staticRenderFns } from "./OnboardingOverlay.vue?vue&type=template&id=1c36b18c&scoped=true&"
import script from "./OnboardingOverlay.vue?vue&type=script&lang=ts&"
export * from "./OnboardingOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingOverlay.vue?vue&type=style&index=0&id=1c36b18c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c36b18c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1c36b18c', component.options)
    } else {
      api.reload('1c36b18c', component.options)
    }
    module.hot.accept("./OnboardingOverlay.vue?vue&type=template&id=1c36b18c&scoped=true&", function () {
      api.rerender('1c36b18c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/courses/CoursePage/components/OnboardingOverlay.vue"
export default component.exports